import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import '../../../assets/js/admin.js';
import { Router, RouterModule } from '@angular/router';
import { UtilServico } from '../../servicos/util.servico';
@Component({
  selector: 'app-layout-inicial',
  templateUrl: './layout-inicial.component.html',
  styleUrls: ['./layout-inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutInicialComponent {

  redeSocial:any = [];
  constructor(private router: Router,     private UtilServico: UtilServico) { } 
  logout() {
    localStorage.removeItem('AcessoAdm');
    this.router.navigate(['/login']);


  }

}



// WEBPACK FOOTER //
// ./src/app/layout/layout-inicial/layout-inicial.component.ts